import { tenantKeys } from "./tenants";

export const managerKeys = {
  base: (tenantId: string) =>
    [...tenantKeys.detail(tenantId), "managers", "v1"] as const,
  list: (tenantId: string) => [...managerKeys.base(tenantId), "list"] as const,
};
